import { useQuery } from 'react-query'
import { apiGetGlobalSearch } from '../api/global-search-api'

export const useGlobalSearch = ({
  vin,
  searchString,
  searchCategories = 'all', // can be 'all' or an array of categories
}) => {
  const {
    status,
    data: results,
    error,
    isFetching,
    isLoading,
    isError,
    isSuccess,
  } = useQuery(
    ['global-search', vin, ...searchCategories, searchString],
    async () => {
      const result = await apiGetGlobalSearch({
        vin,
        searchString,
        searchCategories: searchCategories === 'all' ? 'all' : searchCategories,
      })
      return result.data
    },
    {
      refetchOnWindowFocus: false,
      enabled: !!searchString && !!vin,
    },
  )

  return {
    status,
    results,
    error,
    isLoading,
    isFetching,
    isError,
    isSuccess,
  }
}

// Thin wrappers
export const useSearchDTCs = ({ vin, searchString }) => {
  return useGlobalSearch({ vin, searchString, searchCategories: ['dtc'] })
}
